module.exports = __webpack_public_path__ + "static/media/alert-circle-ellipse.8e164817.svg";